import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            position: 'static',
            maxHeight: 520,
        },
        tableContent: {
            boxShadow: 'none !important',
        },
    }
})

export default useStyles
